// extracted by mini-css-extract-plugin
export default {"form-control":"SearchInput_form-control__S4Nxy"};